import { lazy } from '~/router/lazy'
import type { AppRouteObject } from '~/router/types'

export const chatsRoute: AppRouteObject = {
  path: 'chats',
  children: [
    {
      index: true,
      handle: { title: 'Chats' },
      lazy: lazy(() => import('~/pages/chats/Chats')),
    },
    {
      path: 'channel-1',
      handle: { title: 'Channel 1' },
      lazy: lazy(() => import('~/pages/chats/ChatsChannel')),
    },
    {
      path: 'channel-2',
      handle: { title: 'Channel 2' },
      lazy: lazy(() => import('~/pages/chats/ChatsChannel')),
    },
  ],
}
